__turbopack_context__.v({
  "animate": "PressLogos-module__8Nvjbq__animate",
  "pressScroll": "PressLogos-module__8Nvjbq__pressScroll",
  "root": "PressLogos-module__8Nvjbq__root",
});
